/**
 * Query string for GET /order/:id — matches UI language (i18n), not browser Accept-Language alone.
 * @param {string | undefined} i18nLanguage
 * @returns {string}
 */
export function buildOrderDetailLangQuery(i18nLanguage) {
  const lang = encodeURIComponent(String(i18nLanguage || 'en-us').toLowerCase().replace('_', '-'));
  return `lang=${lang}`;
}
